<div class="title-section">
	<img src="/assets/images/tilburg-logo.png" alt="Logo image" />
	<h1 class="title">{{ title | translate }}</h1>
</div>
